<template>
  <div>
    <template v-if="!isEdit">
      <v-layout>
        <v-flex class="form-control pa-2">{{ name }}</v-flex>
        <v-flex class="form-control pa-2 grey--text">{{ variable.description }}</v-flex>
        <template
          v-if="
            (type == 'global' && $store.state.superadmin.includes($store.state.userid)) ||
              type == 'local'
          "
        >
          <v-btn fab small color="primary" depressed @click="onEdit">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn fab small color="primary" depressed @click="$emit('onDelete')">
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </v-layout>
    </template>
    <template v-else>
      <v-layout>
        <v-flex class="form-control pa-1" :class="{ 'has-error': errors.has('variable_name') }">
          <input
            type="text"
            class="mb-0"
            placeholder="Variable name"
            data-vv-as="Variable name"
            name="variable_name"
            v-validate="`required|excluded:${excludeName}`"
            v-model="name"
          />
          <span class="text-error">{{ errors.first('variable_name') }}</span>
        </v-flex>
        <v-flex class="form-control pa-1">
          <input
            type="text"
            class="mb-0"
            placeholder="Possible Value"
            v-model="variable.description"
          />
        </v-flex>
        <v-btn fab small color="primary" depressed @click="onSave">
          <v-icon>check</v-icon>
        </v-btn>
        <v-btn fab small color="primary" depressed @click="onCancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: ['value', 'type'],
  data() {
    return {
      isEdit: false,
      variable: {
        name: '',
        description: ''
      },
      onlyThisPage: true,
      name: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variableList: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    filterVariable() {
      var vm = this
      if (!vm.selectedFlow) {
        return []
      }
      return vm.variableList.filter(el => {
        return el.flowid == vm.selectedFlow.id
      })
    },
    excludeName() {
      var result = []
      var vm = this
      vm.filterVariable.map(el => {
        if (vm.variable.id && vm.variable.id == el.id) {
        } else {
          var name = el.name.split(`flow${vm.$store.state.selectedFlow.id}.`)
          if (name.length > 1) {
            delete name[0]
            result.push(name.join(''))
          } else {
            result.push(name)
          }
        }
      })
      if (this.type == 'global') {
        result.push('msg')
      }
      return result.join(',')
    }
  },
  mounted() {
    if (this.value) {
      this.variable = this.value
    } else {
      this.isEdit = true
    }
    this.name = this.resetName(this.variable.name)
    this.cached_variable = JSON.stringify(this.variable)
  },
  methods: {
    resetName(name) {
      if (name && name != null) {
        if (this.type == 'local') {
          return name.replace(`flow${this.$store.state.selectedFlow.id}.`, '')
          // var name = name.split(`flow${this.$store.state.selectedFlow.id}.`)
          // if (name.length > 1) {
          //   delete name[0]
          //   return name.join('')
          // } else {
          //   return name
          // }
        } else {
          // if (name.includes(`${this.$store.state.selectedBot.pageid}.`)) {
          //   this.onlyThisPage = true
          //   return name.replace(`${this.$store.state.selectedBot.pageid}.`, '')
          // } else {
          //   this.onlyThisPage = false
          //   return name
          // }
          return name
        }
      } else {
        return ''
      }
    },
    onCancel() {
      this.isEdit = false
      this.$emit('onCancel')
      this.variable = JSON.parse(this.cached_variable)
      this.name = this.resetName(this.variable.name)
    },
    onSave() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }

        var data = {
          name: vm.type == 'local' ? `flow${vm.$store.state.selectedFlow.id}.${vm.name}` : vm.name,
          description: vm.variable.description,
          flowid: vm.type == 'local' ? vm.$store.state.selectedFlow.id : 0
        }
        if (vm.variable.id) {
          data.id = vm.variable.id
        }
        vm.$emit('onSave', data)
        vm.variable = data
        vm.cached_variable = JSON.stringify(data)
        vm.isEdit = false
      })
    },
    onEdit() {
      this.isEdit = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/AddVariable.vue